export const ProfileRoutes = [
  {
    path: 'profile',
    name: 'profileRoot',
    redirect: { name: 'accountSettings' },
  },
  {
    path: 'profile/account',
    name: 'profileAccountSettings',
    redirect: { name: 'accountSettings' },
  },
  {
    path: 'profile/authentication',
    name: 'profileAuthenticationSettings',
    redirect: { name: 'accountSettings' },
  },
  {
    path: 'profile/data',
    name: 'profileDataSettings',
    redirect: { name: 'accountSettings' },
  },
];

export const OnboardingRoutes = [
  {
    path: 'account/verify',
    name: 'onboardingVerifyAccount',
    component: () => import(/* webpackChunkName: "onboarding" */ './OnboardingVerifyAccount.vue'),
    meta: {
      welcome: true,
      onboarding: true,
    },
  },
  {
    path: 'account/company',
    name: 'onboardingCreateCompany',
    component: () => import(/* webpackChunkName: "onboarding" */ './OnboardingCreateCompany.vue'),
    meta: {
      welcome: true,
      onboarding: true,
    },
  },
];
